<template>
    <div v-if="loaded" class="inputContainer" @click="stopEvent($event)">
        <input :value="color" placeholder="#ffffff" @input="updateValue" required>
        <div @click="showPicker = true" v-bind:style="{backgroundColor: color ? color : 'white'}"
             class="color-div"></div>
        <chrome-picker class="my-color-picker" v-if="showPicker && color" v-model="color" @input="updateValue"/>
    </div>
</template>

<script>
    import {Chrome as ColorPicker} from 'vue-color';


    export default {
        name: "ColorInput",
        data: function () {
            return {
                showPicker: false,
                color: '',
                loaded: false
            };
        },
        components: {
            'chrome-picker': ColorPicker
        },
        props: {
            value: String
        },
        methods: {
            updateValue: function (value) {
                if (value instanceof InputEvent) {
                    console.log(value);
                    this.color = value.target.value;
                } else if (Object.prototype.hasOwnProperty.call(value, 'hex')) {
                    this.color = value.hex;
                } else {
                    this.color = value;
                }

                this.$emit('input', this.color);
            },
            stopEvent(event) {
                event.stopPropagation();
            }
        },
        mounted() {
            this.color = this.value;
            document.body.addEventListener('click', () => {
                this.showPicker = false;
            });
            this.loaded = true;
        }
    }
</script>

<style lang="scss" scoped>
    .inputContainer {
        position: relative;
        min-width: 100px;
    }

    .color-div {
        width: 24px;
        height: 22px;
        position: absolute;
        right: 1px;
        top: 1px
    }

    .my-color-picker {
        position: absolute;
        z-index: 5;
        right: -50px;
        top: -250px;
    }

    input {
        height: 24px;
        width: 100%;
        position: relative;
    }

</style>